<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span (click)="modalReference.close(false)">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="d-flex justify-content-center flex-column">
            <span class="mx-auto mt-1"> {{ 'ACTIVITY_LOGS.TITLE' | translate | uppercase }}: </span>
            <span for="requested" class="mx-auto mt-5">{{ 'ACTIVITY_LOGS.DATE' | translate | uppercase }}:</span>
            <div class="date-container mx-auto my-2">
                <input type="text" id="date" ngxDaterangepickerMd [locale]="locale" [showClearButton]="true" [(ngModel)]="requestedDateRange" (change)="applyFilterByReqDate()" name="requestedDateRange" />
            </div>
            <div class="mx-auto my-5">
                <button class="activity-log-modal-btn" [attr.disabled]="startDate && endDate ? null : true" (click)="downloadLogs()">{{ 'ACTIVITY_LOGS.DOWNLOAD_BTN' | translate | uppercase }}</button>
            </div>
            <div class="mx-auto">
                <span class="mx-auto mt-1"> {{ 'ACTIVITY_LOGS.CONTACT_MESSAGE_START' | translate | uppercase }} <a href="mailto:support@stratipath.com?subject=Loggutdrag&body=Vänligen skicka loggutdraget.">SUPPORT&#64;STRATIPATH.COM</a> {{ 'ACTIVITY_LOGS.CONTACT_MESSAGE_END' | translate | uppercase }} </span>
            </div>
        </div>
    </div>
</ng-template>